import * as React from "react"
import Echo from "laravel-echo"
import {getRawToken} from "../helpers/session";
import {pid, WEBSOCKET_SERVER} from "../config/api-config";
import {godProjectId, isGodModeOn} from "../helpers/api";

const w: any = window
w.io = require('socket.io-client');

const bearerToken = getRawToken()

export const echo = w.Echo = WEBSOCKET_SERVER ? new Echo({
    broadcaster: 'socket.io',
    host: WEBSOCKET_SERVER,
    namespace: '',
    transports: ["websocket"],
    auth: {headers: {Authorization: "Bearer " + bearerToken}}
}) : null

interface Listener {
    name: string
    callback: Function
    general?: boolean
}

interface Props {
    listeners: Listener[]
}

class Websocketeer extends React.PureComponent<Props> {
    private listening = false

    componentDidMount() {
        const w:any = window
        if (typeof w.io !== 'undefined') {
            if (this.listening === false) {
                this.listening = true
                if (this.props.listeners && echo) {
                    this.props.listeners.forEach((listener) => {
                        const channel = listener.general === true ? 'general' : 'private-project.' + (isGodModeOn ? godProjectId : pid)
                        echo.channel(channel)
                            .listen(listener.name, listener.callback)
                    })
                }
            }
        }
    }

    public render() {
        return false
    }
}

export default Websocketeer